mutation DocumentPoolUploadDocument(
  $document: DocumentUploadInput!
  $documentPoolId: UUID!
) {
  documentPoolUploadDocument(
    document: $document
    documentPoolId: $documentPoolId
  ) {
    uploadLink
    document {
      _documentFileId
    }
  }
}
